import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=13f79cd2&"
import script from "./NotificationMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports